export default "__VITE_ASSET__DC6wjAY0__"